import React from 'react';
import CloudAcquisitionTableComponent from
  '../Components/CloudAcquisitionTableComponent.jsx';
import CloudAcquisitionTopicBuildContainer
  from '../Containers/CloudAcquisitionTopicBuildContainer.jsx';

export const _refreshHandler = (key) => {
  switch (key) {
    case 1:
      if (!location.hash.endsWith('#/cloud/') && !location.hash.endsWith('#/cloud')) {
        location.hash = '#/cloud/passwordRuns';
      }
      break;
    case 2:
      location.hash = '#/cloud/tokenRuns';
      break;
    case 3:
      location.hash = '#/cloud/topicPasswordRuns';
      break;
  }
};

export const _topicQueryHandler = (buildNumber) => {
  if (buildNumber !== '' && buildNumber > 0) {
    location.hash = '#/cloud/topicPasswordRuns?=' + buildNumber;
  } else {
    location.hash = '#/cloud/topicPasswordRuns';
  }
};

export const _getKeyFromHash = (hashValue) => {
  if (hashValue.startsWith('#/cloud/passwordRuns')) {
    return 1;
  }
  else if (hashValue.startsWith('#/cloud/tokenRuns')) {
    return 2;
  }
  else if (hashValue.startsWith('#/cloud/topicPasswordRuns')) {
    return 3;
  } else {
    return 1;
  }
};

export const _parseHash = (hashValue) => {
  if (hashValue.indexOf('=') + 1 !== hashValue.length) {
    const number = hashValue.substring(
      hashValue.indexOf('=') + 1, hashValue.length + 1
    );
    if (number > 0) {
      return number;
    }
  }
  else if (hashValue.indexOf('=') + 1 === hashValue.length) {
    const number = hashValue.substring(
      hashValue.indexOf('=') + 1
    );
    if (number > 0) {
      return number;
    }
  }
  return '';
};

export const _handleChange = (event) => {
  _topicQueryHandler(event.target.value);
};

export const _passwordRunPage = (acquisitions) => {
  return (
    <CloudAcquisitionTableComponent acquisitions={
      acquisitions.filter(function (acquisition) {
        return !acquisition.isTokenRun && acquisition.topicJobNumber === 0;
      })}
    />
  );
};

export const _tokenRunPage = ( acquisitions ) => {
  return (
    <CloudAcquisitionTableComponent acquisitions={
      acquisitions.filter(function (acquisition) {
        return acquisition.isTokenRun && acquisition.topicJobNumber === 0;
      })}
    />
  );
};

export const _topicPasswordPage = () => {
  return (<CloudAcquisitionTopicBuildContainer />);
};


// WEBPACK FOOTER //
// src/helpers/cloudhelpers.js